export function resolveDisplayedVariantIds(
  allVariantIds: string[],
  requestedVariantIds: string[] | undefined,
): string[] {
  if (requestedVariantIds === undefined) return allVariantIds
  const requested = new Set(requestedVariantIds)
  const existing = allVariantIds.filter((id) => requested.has(id))
  return existing.length > 0 ? existing : allVariantIds
}
